export default __webpack_public_path__ + "static/logo_client_Weyerheser@2x-ccb52583a178cdb444fab9d558d3c532.png";